import { lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './Common/Header/Header';
import Footer from './Common/Footer/Footer';
import PageLoader from './Common/Loading/PageLoader';

// Lazy load all page components for better performance
const HomePageRedirect = lazy(() => import('./Pages/HomePage/HomePageRedirect'));
const About = lazy(() => import('./Pages/About/About'));
const Terms = lazy(() => import('./Pages/Terms/Terms'));
const Awards = lazy(() => import('./Pages/AwardsPage/Awards'));
const Categories = lazy(() => import('./Pages/Categories/Categories'));
const Nominee = lazy(() => import('./Pages/Nominee/Nominee'));
const BarChart = lazy(() => import('./Pages/Results/Results'));

function App() {
  const location = useLocation();

  return (
    <div className="App min-h-screen flex flex-col bg-neutral-50">
      <Header />

      <main className="flex-1 overflow-x-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <Suspense fallback={<PageLoader />}>
              <Routes location={location}>
                <Route path="/" element={<HomePageRedirect />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/awards/:id" element={<Awards />} />
                <Route path="/categories/:id" element={<Categories />} />
                <Route path="/nominee/:id" element={<Nominee />} />
                <Route path="/bar" element={<BarChart />} />
              </Routes>
            </Suspense>
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}

export default App;
